import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { createCustomPropType, isNumeric } from '../../../js/app/react/validators';

class SummaryView extends Component {
  componentDidMount() {}

  render() {
    const { Workflow } = this.props;
    return (
      <Workflow
        {...this.props}
        goToSummaryWhenReady="1"
      />
    );
  }
}

SummaryView.propTypes = {
  clientId: createCustomPropType(isNumeric).isRequired,
  workflowId: PropTypes.string.isRequired,
  Workflow: PropTypes.func.isRequired,
};

export default SummaryView;
